import { render, staticRenderFns } from "./ArticleNotificationOrderItem.vue?vue&type=template&id=62349c9b"
import script from "./ArticleNotificationOrderItem.vue?vue&type=script&lang=js"
export * from "./ArticleNotificationOrderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports